var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#06004a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M867.07-398.5 562.5-93.17q-10.02 9.69-22.68 14.42-12.65 4.73-25.57 4.73T488.93-79q-12.41-4.98-22.43-14.17L94.41-466.02q-9.19-9.2-14.79-21.62-5.6-12.42-5.6-26.12v-304.33q0-28.1 19.94-48.11 19.95-20.02 47.95-20.02h305.33q13.57 0 26.29 5.48 12.72 5.47 22.21 14.91l371.33 370.85q10.56 10.28 15.47 22.94 4.92 12.67 4.92 25.55t-5.1 25.84q-5.1 12.95-15.29 22.15ZM246.88-662.57q20.79 0 36.17-15.38 15.38-15.39 15.38-36.23 0-20.84-15.35-36.25-15.35-15.42-36.14-15.42-21.03 0-36.41 15.39-15.38 15.39-15.38 36.23 0 20.83 15.35 36.25 15.36 15.41 36.38 15.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/other-icon.fa6f281d4bc6dcfb9bfc3cfe246db0d8.svg";
export { ForwardRef as ReactComponent };